import { Pipe, PipeTransform } from '@angular/core';
import { TokenStorageService } from 'src/app/shared/services/token-storage.service';
import { ProgramType } from 'src/app/shared/enums/program-type.enum';

@Pipe({
  name: 'traineeToOtherRoles',
  standalone: false
})
export class TraineeToOtherRolesPipe implements PipeTransform {
  constructor(private readonly tokenStorage: TokenStorageService) {}

  public transform(text: string, type: ProgramType = null): string {
    if (type === null) {
      type = this.tokenStorage.userInfo.CurrentProgram.Type;
    }

    switch (type) {
      case ProgramType.FieldTraining:
        return text;
      case ProgramType.PerformanceEvaluation:
        return text
          .replace(/A trainee/g, 'An employee')
          .replace(/Trainee/g, 'Employee')
          .replace(/a trainee/g, 'an employee')
          .replace(/trainee/g, 'employee');
      case ProgramType.ProbationaryPeriod:
        return text
          .replace(/A trainee/g, 'An employee')
          .replace(/Trainee/g, 'Employee')
          .replace(/a trainee/g, 'an employee')
          .replace(/trainee/g, 'employee');
      case ProgramType.Mentoring:
        return text.replace(/Trainee/g, 'Mentee').replace(/trainee/g, 'mentee');
    }
  }
}
